import React, { useState } from "react";

/*
    A password field with the show/hide eye — the Security page needs three of
    them, so the toggle state lives here rather than being tracked once per
    field by the page.

    The eye is a real <button type="button">: it was an <i> with an onClick in
    the old Change Password modal, which no keyboard could reach and no screen
    reader announced. `tabIndex={-1}` keeps it out of the tab order between
    fields — the toggle is a convenience, and Tab should go to the next field.

    Same Font Awesome glyphs the modal used, so nothing new is introduced.
*/
const PasswordField = ({
  label,
  name,
  value,
  onChange,
  autoComplete = "off",
  disabled = false,
}) => {
  const [visible, setVisible] = useState(false);
  const id = `field-${name}`;

  return (
    <div className="gb-field-group">
      <label className="gb-label" htmlFor={id}>
        {label}
      </label>
      <input
        id={id}
        className="gb-field gb-field--with-toggle"
        type={visible ? "text" : "password"}
        name={name}
        value={value}
        onChange={onChange}
        autoComplete={autoComplete}
        disabled={disabled}
        required
      />
      <button
        type="button"
        className="gb-field__toggle"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? `Hide ${label}` : `Show ${label}`}
        aria-pressed={visible}
        tabIndex={-1}
      >
        <i className={visible ? "fas fa-eye-slash" : "fas fa-eye"} />
      </button>
    </div>
  );
};

export default PasswordField;
